// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ew-0";
export var headerCellHover = "_ew-1";